import { Text } from "@chakra-ui/react";
import React from "react";

function NoData(){
    return(
        <Text color={'red'}>データがありません</Text>
    )
}

export default NoData;